// Diagnose-Ausgaben für den Support-Fall (Upload-Routing, Audio-Reset).
//
// Standardmäßig stumm. Einschalten im Browser des Talents bzw. Admins:
//   localStorage.setItem('tro-vs-debug', '1')   → Reload
// Dann erscheinen die Zeilen als `console.debug` (in Chrome unter „Verbose").
// console.warn/error bleiben davon unberührt und sind immer sichtbar.

const FLAG_KEY = 'tro-vs-debug';

let cached: boolean | null = null;

export function isDebugEnabled(): boolean {
  if (cached !== null) return cached;
  try {
    cached = typeof localStorage !== 'undefined' && localStorage.getItem(FLAG_KEY) === '1';
  } catch {
    cached = false; // privater Modus / blockierter Speicher
  }
  return cached;
}

export function debugLog(...args: unknown[]): void {
  if (isDebugEnabled()) console.debug(...args);
}
